import {isObject, last, toLower} from "lodash";
import i18n from "../i18n";
import {reportType} from "../constans/reports";
import {upperFirstLetter} from "./TextUtils";
import {getEventsList} from "./EventsViewUtils";
import {AnimalTypes} from "../constans/animalTypes";

export const permissionTranslator = (name) => {
    if (name.includes("PV_RE_REPORT")) {
        name = last(name.split("-"));
        return i18n.t(`newReports.headers.${name}`);
    } else {
        name = last(name.split("_"));
    }
    switch (name) {
        case "climates":
            return i18n.t("climate");
        case "simple":
            return i18n.t("simpleView");
        case "advanced":
            return i18n.t("advancedView");
        case "skipDoses":
            return i18n.t("deviceRows.feeding.dispenserButtons.skipDoses");
        case "assignAnimal":
            return i18n.t("deviceRows.feeding.dispenserSimpleButtons.assign");
        case "changingDispenserMode":
            return i18n.t("permissions.changingDispenserMode");
        case "reportingInsemination":
            return i18n.t("permissions.reportingInsemination");
        case "deletePig":
            return i18n.t("deviceRows.feeding.dispenserButtons.deletePig");
        case "reportingParturition":
            return i18n.t(
                "deviceRows.feeding.dispenserButtons.reportParturition"
            );
        case "diodeEnable":
            return i18n.t("settings.diodeEnable");
        case "nutriGroup":
            return i18n.t("Nutri Group");
        case "clearAlarms":
            return i18n.t("deviceRows.feeding.deviceItem.clearAlerts");
        case "moveAnimal":
            return i18n.t("deviceRows.feeding.dispenserButtons.deletePig");
        case "general":
            return i18n.t("farmNotificationListItem.General");
        case "newSettlement":
            return i18n.t("settlements.startNewSettlement");
        case "bandwith":
            return i18n.t("settings.bandwithVenting");
        case "matSettings":
            return i18n.t("farmView.climate.matSettings");
        case "waterMatSettings":
            return i18n.t("settings.waterMatsSettings");
        case "clearAlerts":
            return i18n.t("deviceRows.feeding.deviceItem.clearAlerts");
        case "SK":
            return "SK3 / SK4";
        case "name":
            return i18n.t("newSettings.devices.manage.name");
        case "resumeWork":
            return i18n.t("chamber.separationCageInfo.resumeWork");
        case "changeExpedition":
            return i18n.t("settings.editExpedition");
        case "endExpedition":
            return i18n.t("settings.endExpedition");
        case "markerSettings":
            return i18n.t("chamber.separationCageInfo.marker");
        case "endSettlement":
            return i18n.t("modals.closeSettlement.title");
        case "newInsertion":
            return i18n.t("farmView.cage.newInsertion");
        case "lockFeeding":
            return `${i18n.t("basics.chart.block")} / ${i18n.t(
                "unlockFeeding"
            )}`;
        case "weightTaring":
            return i18n.t("IOT.weightTaring");
        case "alarmSettings":
            return i18n.t("deviceRows.waterFlowMeter.waterTab.alarms");
        case "settlementEdit":
            return i18n.t("settings.settlementEdit");
        case "settlementAdd":
            return i18n.t("settings.settlementAdd");
        case "ipsum":
            return "IPSUM";
        case "nutripro":
            return "Nutri PRO";
        case "doTare":
            return i18n.t("settings.doTare");
        case "startMotor":
            return i18n.t("deviceRows.chainFeeding.chainFeedingTab.startMotor");
        case "stopMotor":
            return i18n.t("deviceRows.chainFeeding.chainFeedingTab.stopMotor");
        case "deleteAlarm":
            return i18n.t("farms.tabs.generalTab.deleteAlarm");
        case "results":
            return i18n.t("results.results");
        case "view":
            return i18n.t("preview");
        case "generate":
            return i18n.t("newReports.headers.generate");
        case "weekDay":
            return i18n.t("grid.weekDay");
        case "parturitions":
            return i18n.t("parturition");
        case "dates":
            return `${i18n.t("grid.weekDay")} / ${i18n.t("week")} / ${i18n.t(
                "month"
            )} / ${i18n.t("year")}`;
        case "sow":
            return upperFirstLetter(i18n.t("animalKind.0"));
        case "weaner":
            return upperFirstLetter(i18n.t("animalKind.2"));
        case "porker":
            return upperFirstLetter(i18n.t("animalKind.3"));
        case "reproduction":
            return upperFirstLetter(toLower(i18n.t("planTypes.reproduction")));
        case "group":
            return i18n.t("pigletOrPorker");
        case "farm":
            return i18n.t("breeding");
        case "chooser":
            return i18n.t("dosatron");
        case "scheduleOfTreatmentPiglet":
            return i18n.t("scheduleOfTreatment");
        case "fallPiglet":
            return i18n.t("fall");
        case "graftingPiglet":
            return i18n.t("grafting");
        case "weightingPiglet":
            return i18n.t("weighting");
        case "isMommy":
            return i18n.t("eventTypes.W");
        case "separationToHouse":
            return i18n.t("separationToPigletHouse");
        case "fallTattooeds":
            return i18n.t("fallTattooedPiglets");
        case "falls":
            return i18n.t("fallPiglets");
        case "building":
            return i18n.t("newSettings.buildings.building");
        case "farmwatch":
            return i18n.t("farmWatchProControlPanel");
        case "validations":
            return i18n.t("validationsView.validations");
        case "cloudbox":
            return i18n.t("cloudBoxCommunication");
        case "settings":
            return i18n.t("settings.settings");
        case "create":
            return i18n.t("localPermission.create");
        case "assignUser":
            return i18n.t("localPermission.assignUser");
        case "unAssignUser":
            return i18n.t("localPermission.UnAssignUser");
        case "designation":
            return upperFirstLetter(
                i18n.t("shadowDescription.FARM_WATCH_TEMP.SName._title")
            );
        case "assignedUser":
            return i18n.t("localPermission.assignedUsers");
        case "observers":
            return i18n.t("localPermission.observers");
        case "changeProjectColor":
            return i18n.t("apiNotifications.changeProjectColorTitle");
        case "deleteProject":
            return i18n.t("apiNotifications.removeProjectTitle");
        case "dashboard":
            return i18n.t("localPermission.dashboard");
        case "closeAssigned":
            return i18n.t("localPermission.closeAssigned");
        case "changeProjectName":
            return i18n.t("changeName");
        case "autoTare":
            return i18n.t("settings.autoTare");
        case "status":
            return i18n.t("localPermission.changeStatus");
        case "description":
            return upperFirstLetter(
                i18n.t("subscriptions.grid.adminYearlyPlan1.1")
            );

        default:
            return i18n.t(name);
    }
};

export const isPermissionDisabled = (
    key,
    permissions = {},
    reverse = false
) => {
    if (permissions === "loading") return reverse ? false : true; //Jeżeli jeszcze ładuje
    if (isObject(permissions) && Object.keys(permissions).length === 0) {
        // Jeżeli nie ma żadnych uprawnień nadanych
        return false;
    }
    return permissions[key] === false ? key : false;
};

export const localPermissionStatus = (key, permissions) => {
    if (permissions === "loading") return "loading";
    if (isObject(permissions) && Object.keys(permissions).length === 0)
        return "noPermissions";
    return permissions[key] === true ? "block" : "allow";
};

export const permissionKeys = {
    //KARMIENIE

    ANIMALS: "PV_A_animals",

    ANIMALS_GENERAL: "PV_A_1000_general",
    ANIMALS_GENERAL_REMOVEANIMALS: "PV_A_1001_removeAnimals",

    FEEDING: "PV_F_feeding",

    FEEDING_ADVANCED: "PV_F_1000_advanced",
    FEEDING_ADVANCED_MANAGEFEEDING: "PV_F_1001_manageFeeding",
    FEEDING_ADVANCED_ALARMS: "PV_F_1002_alarms",
    FEEDING_ADVANCED_UNLOCKFEEDING: "PV_F_1003_unlockFeeding",
    FEEDING_ADVANCED_EXTRAFEEDING: "PV_F_1004_extraFeeding",
    FEEDING_ADVANCED_SKIPDOSES: "PV_F_1005_skipDoses",
    FEEDING_ADVANCED_LOCKFEEDING: "PV_F_1006_lockFeeding",
    FEEDING_ADVANCED_REPORTCONDITION: "PV_F_1007_reportCondition",
    FEEDING_ADVANCED_DELETEPIG: "PV_F_1008_deletePig",
    FEEDING_ADVANCED_REPORTINGINSEMINATION: "PV_F_1009_reportingInsemination",
    FEEDING_ADVANCED_REPORTINGPARTURITION: "PV_F_1010_reportingParturition",
    FEEDING_ADVANCED_DISABLEDISPENSER: "PV_F_1011_disableDispenser",
    FEEDING_ADVANCED_EMPTYDISPENSER: "PV_F_1012_emptyDispenser",
    FEEDING_ADVANCED_EXTRAWATER: "PV_F_1013_extraWater",
    FEEDING_ADVANCED_DIODEENABLE: "PV_F_1014_diodeEnable",
    FEEDING_ADVANCED_ASSIGNANIMAL: "PV_F_1015_assignAnimal",
    FEEDING_ADVANCED_TEMPERATURESETTINGS: "PV_F_1016_temperatureSettings",

    FEEDING_SIMPLE: "PV_F_2000_simple",
    FEEDING_SIMPLE_DISABLEDISPENSER: "PV_F_2001_disableDispenser",
    FEEDING_SIMPLE_MANAGEFEEDING: "PV_F_2002_manageFeeding",
    FEEDING_SIMPLE_CHANGINGDISPENSERMODE: "PV_F_2003_changingDispenserMode",
    FEEDING_SIMPLE_REPORTINGINSEMINATION: "PV_F_2004_reportingInsemination",
    FEEDING_SIMPLE_ASSIGNANIMAL: "PV_F_2005_assignAnimal",
    FEEDING_SIMPLE_ALARMS: "PV_F_2006_alarms",
    FEEDING_SIMPLE_EMPTYDISPENSER: "PV_F_2007_emptyDispenser",
    FEEDING_SIMPLE_SKIPDOSES: "PV_F_2008_skipDoses",
    FEEDING_SIMPLE_EXTRAFEEDING: "PV_F_2009_extraFeeding",
    FEEDING_SIMPLE_DOSECORRECTION: "PV_F_2010_doseCorrection",

    FEEDING_GROUP: "PV_F_3000_nutriGroup",
    FEEDING_GROUP_LOCKFEEDING: "PV_F_3001_lockFeeding",
    FEEDING_GROUP_CLEARALARMS: "PV_F_3002_clearAlarms",
    FEEDING_GROUP_EXTRAFEEDING: "PV_F_3003_extraFeeding",
    FEEDING_GROUP_EXTRAWATER: "PV_F_3004_extraWater",
    FEEDING_GROUP_EMPTYDISPENSER: "PV_F_3005_emptyDispenser",
    FEEDING_GROUP_MANAGEFEEDING: "PV_F_3006_manageFeeding",
    FEEDING_GROUP_MOVEANIMAL: "PV_F_3007_moveAnimal",
    FEEDING_GROUP_REPORTCONDITION: "PV_F_3008_reportCondition",

    FEEDING_GENERAL: "PV_F_4000_general",
    FEEDING_GENERAL_NEWSETTLEMENT: "PV_F_4001_newSettlement",

    /// KLIMATY
    CLIMATES: "PV_C_climates",

    CLIMATES_SK: "PV_C_1000_SK",
    CLIMATES_SK_WORKTYPE: "PV_C_1001_workType",
    CLIMATES_SK_ALARMS: "PV_C_1002_alarms",
    CLIMATES_SK_BANDWITH: "PV_C_1003_bandwith",
    CLIMATES_SK_MATSETTINGS: "PV_C_1004_matSettings",
    CLIMATES_SK_WATERMATSETTINGS: "PV_C_1005_waterMatSettings",
    CLIMATES_SK_CLEARALERTS: "PV_C_1006_clearAlerts",

    CLIMATES_NRF: "PV_C_2000_NRF",
    CLIMATES_NRF_ALARMS: "PV_C_2001_alarms",

    CLIMATES_CLIMATE: "PV_C_3000_climate",
    CLIMATES_CLIMATE_CONFIGURATION: "PV_C_3001_configuration",

    CLIMATES_TEMPERATURE: "PV_C_4000_temperature",
    CLIMATES_TEMPERATURE_CONFIGURATION: "PV_C_4001_configuration",
    CLIMATES_TEMPERATURE_NAME: "PV_C_4002_name",

    //STACJA SORTUJĄCA
    CAGE: "PV_CA_cage",

    CAGE_GENERAL: "PV_CA_1000_general",
    CAGE_GENERAL_WORKTYPE: "PV_CA_1001_workType",
    CAGE_GENERAL_RESUME: "PV_CA_1002_resumeWork",
    CAGE_GENERAL_CHANGEEXPEDITION: "PV_CA_1003_changeExpedition",
    CAGE_GENERAL_ENDEXPEDITION: "PV_CA_1004_endExpedition",
    CAGE_GENERAL_MARKERSETTINGS: "PV_CA_1005_markerSettings",
    CAGE_GENERAL_ALARMS: "PV_CA_1006_alarms",
    CAGE_GENERAL_ENDSETTLEMENT: "PV_CA_1007_endSettlement",
    CAGE_GENERAL_NEWINSERTION: "PV_CA_1008_newInsertion",

    //IPSUM
    IPSUM: "PV_I_ipsum",

    IPSUM_GENERAL: "PV_I_1000_general",
    IPSUM_GENERAL_SETSCHEDULE: "PV_I_1001_setSchedule",
    IPSUM_GENERAL_LOCKFEEDING: "PV_I_1002_lockFeeding",
    IPSUM_GENERAL_ALARMS: "PV_I_1003_alarms",
    IPSUM_GENERAL_WEIGHTTARING: "PV_I_1004_weightTaring",
    IPSUM_GENERAL_EXTRAFEEDING: "PV_I_1005_extraFeeding",
    IPSUM_GENERAL_EMPTYDISPENSER: "PV_I_1004_emptyDispenser",
    IPSUM_GENERAL_ALARMSETTINGS: "PV_I_1005_alarmSettings",
    IPSUM_GENERAL_SETTLEMENTEDIT: "PV_I_1006_settlementEdit",
    IPSUM_GENERAL_SETTLEMENTADD: "PV_I_1007_settlementAdd",
    IPSUM_GENERAL_CHOOSEFORAGE: "PV_I_1007_chooseForage",

    //NUTRI PRO
    NUTRIPRO: "PV_NP_nutripro",

    NUTRIPRO_GENERAL: "PV_NP_1000_general",
    NUTRIPRO_GENERAL_FEEDINGCURVE: "PV_NP_1001_feedingCurve",
    NUTRIPRO_GENERAL_SETSCHEDULE: "PV_NP_1002_setSchedule",
    NUTRIPRO_GENERAL_LOCKFEEDING: "PV_NP_1003_lockFeeding",
    NUTRIPRO_GENERAL_ALARMS: "PV_NP_1004_alarms",
    NUTRIPRO_GENERAL_EXTRAFEEDING: "PV_NP_1005_extraFeeding",
    NUTRIPRO_GENERAL_EMPTYDISPENER: "PV_NP_1006_emptyDispenser",
    NUTRIPRO_GENERAL_SETTLEMENTEDIT: "PV_NP_1007_settlementEdit",
    NUTRIPRO_GENERAL_SETTLEMENTADD: "PV_NP_1008_settlementAdd",
    NUTRIPRO_GENERAL_CHOOSEFORAGE: "PV_NP_1009_chooseForage",

    //SILOSY
    SILO: "PV_S_siloses",

    SILO_GENERAL: "PV_S_1000_general",
    SILO_GENERAL_ALARMS: "PV_S_1001_alarms",
    SILO_GENERAL_CHOOSEFORAGE: "PV_S_1002_chooseForage",
    SILO_GENERAL_NAME: "PV_S_1003_name",
    SILO_GENERAL_AUTOTARE: "PV_S_1004_autoTare",

    //WODA
    WATER: "PV_W_water",

    WATER_GENERAL: "PV_W_1000_general",
    WATER_GENERAL_ALARMSETTINGS: "PV_W_1001_alarmSettings",
    WATER_GENERAL_SETTLEMENTEDIT: "PV_W_1002_settlementEdit",
    WATER_GENERAL_SETTLEMENTADD: "PV_W_1003_settlementAdd",

    //PRĄD
    ELECTRICITY: "PV_E_electricity",

    ELECTRICITY_GENERAL: "PV_E_1000_general",
    ELECTRICITY_GENERAL_ALERT: "PV_E_1001_alert",
    ELECTRICITY_GENERAL_SETTLEMENTEDIT: "PV_E_1002_settlementEdit",
    ELECTRICITY_GENERAL_SETTLEMENTADD: "PV_E_1003_settlementAdd",
    ELECTRICITY_GENERAL_SWITCHMETER: "PV_E_1004_switchMeter",

    //WAGA NAJAZDOWA
    VEHICLEWEIGHT: "PV_VW_vehicleWeight",

    VEHICLEWEIGHT_GENERAL: "PV_VW_1000_general",
    VEHICLEWEIGHT_GENERAL_DOTARE: "PV_VW_1001_doTare",
    VEHICLEWEIGHT_GENERAL_REPEATWEIGHTING: "PV_VW_1002_repeatWeighting",

    //PASZOCIĄG
    CHAINFEEDING: "PV_CF_chainFeeding",

    CHAINFEEDING_GENERAL: "PV_CF_1000_general",
    CHAINFEEDING_GENERAL_CONFIGURATION: "PV_CF_1001_configuration",
    CHAINFEEDING_GENERAL_STARTMOTOR: "PV_CF_1002_startMotor",
    CHAINFEEDING_GENERAL_STOPMOTOR: "PV_CF_1003_stopMotor",
    CHAINFEEDING_GENERAL_DELETEALARM: "PV_CF_1004_deleteAlarm",

    //WYNIKI
    RESULTS: "PV_R_results",

    RESULTS_GENERAL: "PV_R_1000_general",
    RESULTS_GENERAL_MANAGECOUNTER: "PV_R_1001_manageCounter",
    RESULTS_GENERAL_EDITGOAL: "PV_R_1002_editGoal",
    RESULTS_GENERAL_PRINT: "PV_R_1003_resultsPrint",
    RESULTS_GENERAL_EXCEL: "PV_R_1004_resultsExcel",

    RESULTS_CHANGERANGES: "PV_R_2000_changeRanges",
    RESULTS_CHANGERANGES_WEEKDAY: "PV_R_2001_weekDay",
    RESULTS_CHANGERANGES_WEEKS: "PV_R_2002_week",
    RESULTS_CHANGERANGES_MONTHS: "PV_R_2003_month",
    RESULTS_CHANGERANGES_YEAR: "PV_R_2004_year",
    RESULTS_CHANGERANGES_TECHNOLOGYGROUP: "PV_R_2005_technologyGroup",
    RESULTS_CHANGERANGES_GROUP: "PV_R_2006_group",

    RESULTS_DATES: "PV_R_3000_dates",
    RESULTS_DATES_SOW: "PV_R_3001_sow",
    RESULTS_DATES_WEANER: "PV_R_3002_weaner",
    RESULTS_DATES_PORKER: "PV_R_3003_porker",
    RESULTS_DATES_GILT: "PV_R_3004_gilt",
    RESULTS_DATES_REPRODUCTION: "PV_R_3005_reproduction",
    RESULTS_DATES_PARTURITIONS: "PV_R_3006_parturitions",
    RESULTS_DATES_SEPARATION: "PV_R_3007_separation",

    RESULTS_TECHNOLOGYGROUP: "PV_R_4000_technologyGroup",
    RESULTS_TECHNOLOGYGROUP_SOW: "PV_R_4001_sow",
    RESULTS_TECHNOLOGYGROUP_WEANER: "PV_R_4002_weaner",
    RESULTS_TECHNOLOGYGROUP_PORKER: "PV_R_4003_porker",
    RESULTS_TECHNOLOGYGROUP_GILT: "PV_R_4004_gilt",
    RESULTS_TECHNOLOGYGROUP_REPRODUCTION: "PV_R_4005_reproduction",
    RESULTS_TECHNOLOGYGROUP_PARTURITIONS: "PV_R_4006_parturitions",
    RESULTS_TECHNOLOGYGROUP_SEPARATION: "PV_R_4007_separation",

    RESULTS_GROUP: "PV_R_5000_group",
    RESULTS_GROUP_GENERAL: "PV_R_5001_general",
    RESULTS_GROUP_WEANER: "PV_R_5002_weaner",
    RESULTS_GROUP_PORKER: "PV_R_5003_porker",
    RESULTS_GROUP_GILT: "PV_R_5004_gilt",

    //RAPORTY
    REPORTS: "PV_RE_reports",

    REPORTS_VIEW: "PV_RE_1000_view",
    REPORTS_GENERATE: "PV_RE_2000_generate",
    REPORTS_DELETE: "PV_RE_3000_delete",

    //HODOWLA
    FARM: "PV_F_farm",

    FARM_SOW: "PV_F_1000_sow",
    FARM_WEANER: "PV_F_2000_weaner",
    FARM_PORKER: "PV_F_3000_porker",
    FARM_BOAR: "PV_F_4000_boar",
    FARM_GILT: "PV_F_5000_gilt",

    //USTAWIENIA
    SETTINGS: "PV_S_settings",

    SETTINGS_GENERAL: "PV_S_1000_general",
    SETTINGS_GENERAL_GENERAL: "PV_S_1001_general",
    SETTINGS_GENERAL_BUILDING: "PV_S_1002_building",
    SETTINGS_GENERAL_DEVICES: "PV_S_1003_devices",
    SETTINGS_GENERAL_CLIMATES: "PV_S_1004_climates",
    SETTINGS_GENERAL_CAGE: "PV_S_1005_cage",
    SETTINGS_GENERAL_FARMWATCH: "PV_S_1006_farmwatch",
    SETTINGS_GENERAL_BREEDING: "PV_S_1006_breeding",
    SETTINGS_GENERAL_ECONOMY: "PV_S_1007_economy",
    SETTINGS_GENERAL_FEEDING: "PV_S_1008_feeding",
    SETTINGS_GENERAL_SILO: "PV_S_1009_silo",
    SETTINGS_GENERAL_ROUTINES: "PV_S_1010_routines",
    SETTINGS_GENERAL_TASKS: "PV_S_1011_tasks",
    SETTINGS_GENERAL_VALIDATIONS: "PV_S_1012_validations",
    SETTINGS_GENERAL_CHARTS: "PV_S_1013_charts",
    SETTINGS_GENERAL_SOWCARDGENERATOR: "PV_S_1014_sowCardGenerator",
    SETTINGS_GENERAL_CLOUDBOX: "PV_S_1015_cloudbox",
    SETTINGS_GENERAL_AZW: "PV_S_1016_azw",

    //PROJEKTY
    PROJECTS: "PV_P_projects",

    PROJECTS_GENERAL: "PV_P_1000_general",
    PROJECTS_GENERAL_VIEW: "PV_P_1001_view",
    PROJECTS_GENERAL_CREATE: "PV_P_1002_create",
    PROJECTS_GENERAL_ASSIGN: "PV_P_1003_assignUser",
    PROJECTS_GENERAL_DASHBOARD: "PV_P_1004_dashboard",

    PROJECTS_GENERAL_COLOR: "PV_P_1005_changeProjectColor",
    PROJECTS_GENERAL_DELETE: "PV_P_1006_deleteProject",
    PROJECTS_GENERAL_NAME: "PV_P_1007_changeProjectName",

    //ZADANIA
    TASKS: "PV_T_tasks",

    TASKS_GENERAL: "PV_T_1000_general",
    TASKS_GENERAL_CREATE: "PV_T_1001_create",
    TASKS_GENERAL_DELETE: "PV_T_1002_delete",

    TASKS_EDIT: "PV_T_2000_edit",
    TASKS_EDIT_NAME: "PV_T_2001_designation",
    TASKS_EDIT_ASSIGNEDUSER: "PV_T_2002_assignedUser",
    TASKS_EDIT_STARTDATE: "PV_T_2003_startDate",
    TASKS_EDIT_ENDDATE: "PV_T_2005_endDate",
    TASKS_EDIT_OBSERVERS: "PV_T_2006_observers",
    TASKS_EDIT_LIST: "PV_T_2007_list",
    TASKS_EDIT_ADDFILE: "PV_T_2008_addFile",
    TASKS_EDIT_COMMENT: "PV_T_2009_comment",
    TASKS_EDIT_CHANGESTATUS: "PV_T_2010_status",
    TASKS_EDIT_CATEGORY: "PV_T_2011_category",
    TASKS_EDIT_CLOSEASSIGNED: "PV_T_2012_closeAssigned",
    TASKS_EDIT_DESCRIPTION: "PV_T_2013_description",
};

export function getValueOfEventPicker(value) {
    if (typeof value !== "string") return null;

    const skipWords = ["Porker", "Piglet"];
    const re = new RegExp("[/=]([^/=]+)$");
    const match = value.match(re);
    let result = match ? match[1] : value;
    skipWords.forEach((word) => {
        result = result.replace(word, "").trim();
    });
    return result;
}

export function getAnimalKeyByAnimalType(animalType) {
    switch (animalType) {
        case AnimalTypes.SOW:
            return "SOW";
        case AnimalTypes.PIGLET:
            return "WEANER";
        case AnimalTypes.PORKER:
            return "PORKER";
        case AnimalTypes.BOAR:
            return "BOAR";
        case AnimalTypes.RENOVATION_SOW:
            return "GILT";
        default:
            break;
    }
}

export const getDefaultTemplateInitialData = () => {
    const tmp = {
        Name: "",
        Data: {
            [permissionKeys.ANIMALS]: {
                [permissionKeys.ANIMALS_GENERAL]: {
                    [permissionKeys.ANIMALS_GENERAL_REMOVEANIMALS]: true,
                },
            },
            [permissionKeys.FEEDING]: {
                [permissionKeys.FEEDING_GENERAL]: {
                    [permissionKeys.FEEDING_GENERAL_NEWSETTLEMENT]: true,
                },
                [permissionKeys.FEEDING_ADVANCED]: {
                    [permissionKeys.FEEDING_ADVANCED_MANAGEFEEDING]: true,
                    [permissionKeys.FEEDING_ADVANCED_ALARMS]: true,
                    [permissionKeys.FEEDING_ADVANCED_UNLOCKFEEDING]: true,
                    [permissionKeys.FEEDING_ADVANCED_EXTRAFEEDING]: true,
                    [permissionKeys.FEEDING_ADVANCED_SKIPDOSES]: true,
                    [permissionKeys.FEEDING_ADVANCED_LOCKFEEDING]: true,
                    [permissionKeys.FEEDING_ADVANCED_REPORTCONDITION]: true,
                    [permissionKeys.FEEDING_ADVANCED_DELETEPIG]: true,
                    [permissionKeys.FEEDING_ADVANCED_REPORTINGINSEMINATION]: true,
                    [permissionKeys.FEEDING_ADVANCED_REPORTINGPARTURITION]: true,
                    [permissionKeys.FEEDING_ADVANCED_DISABLEDISPENSER]: true,
                    [permissionKeys.FEEDING_ADVANCED_EMPTYDISPENSER]: true,
                    [permissionKeys.FEEDING_ADVANCED_EXTRAWATER]: true,
                    [permissionKeys.FEEDING_ADVANCED_DIODEENABLE]: true,
                    [permissionKeys.FEEDING_ADVANCED_ASSIGNANIMAL]: true,
                    [permissionKeys.FEEDING_ADVANCED_TEMPERATURESETTINGS]: true,
                    [permissionKeys.FEEDING_ADVANCED_TEMPERATURESETTINGS]: true,
                },
                [permissionKeys.FEEDING_SIMPLE]: {
                    [permissionKeys.FEEDING_SIMPLE_DISABLEDISPENSER]: true,
                    [permissionKeys.FEEDING_SIMPLE_MANAGEFEEDING]: true,
                    [permissionKeys.FEEDING_SIMPLE_CHANGINGDISPENSERMODE]: true,
                    [permissionKeys.FEEDING_SIMPLE_REPORTINGINSEMINATION]: true,
                    [permissionKeys.FEEDING_SIMPLE_ASSIGNANIMAL]: true,
                    [permissionKeys.FEEDING_SIMPLE_ALARMS]: true,
                    [permissionKeys.FEEDING_SIMPLE_EMPTYDISPENSER]: true,
                    [permissionKeys.FEEDING_SIMPLE_SKIPDOSES]: true,
                    [permissionKeys.FEEDING_SIMPLE_EXTRAFEEDING]: true,
                    [permissionKeys.FEEDING_SIMPLE_DOSECORRECTION]: true,
                },
                [permissionKeys.FEEDING_GROUP]: {
                    [permissionKeys.FEEDING_GROUP_LOCKFEEDING]: true,
                    [permissionKeys.FEEDING_GROUP_CLEARALARMS]: true,
                    [permissionKeys.FEEDING_GROUP_EXTRAFEEDING]: true,
                    [permissionKeys.FEEDING_GROUP_EXTRAWATER]: true,
                    [permissionKeys.FEEDING_GROUP_EMPTYDISPENSER]: true,
                    [permissionKeys.FEEDING_GROUP_MANAGEFEEDING]: true,
                    [permissionKeys.FEEDING_GROUP_MOVEANIMAL]: true,
                    [permissionKeys.FEEDING_GROUP_REPORTCONDITION]: true,
                },
            },
            [permissionKeys.CLIMATES]: {
                [permissionKeys.CLIMATES_SK]: {
                    [permissionKeys.CLIMATES_SK_WORKTYPE]: true,
                    [permissionKeys.CLIMATES_SK_ALARMS]: true,
                    [permissionKeys.CLIMATES_SK_BANDWITH]: true,
                    [permissionKeys.CLIMATES_SK_MATSETTINGS]: true,
                    [permissionKeys.CLIMATES_SK_WATERMATSETTINGS]: true,
                    [permissionKeys.CLIMATES_SK_CLEARALERTS]: true,
                },
                [permissionKeys.CLIMATES_NRF]: {
                    [permissionKeys.CLIMATES_NRF_ALARMS]: true,
                },
                [permissionKeys.CLIMATES_CLIMATE]: {
                    [permissionKeys.CLIMATES_CLIMATE_CONFIGURATION]: true,
                },
                [permissionKeys.CLIMATES_TEMPERATURE]: {
                    [permissionKeys.CLIMATES_TEMPERATURE_CONFIGURATION]: true,
                    [permissionKeys.CLIMATES_TEMPERATURE_NAME]: true,
                },
            },
            [permissionKeys.CAGE]: {
                [permissionKeys.CAGE_GENERAL]: {
                    [permissionKeys.CAGE_GENERAL_WORKTYPE]: true,
                    [permissionKeys.CAGE_GENERAL_RESUME]: true,
                    [permissionKeys.CAGE_GENERAL_CHANGEEXPEDITION]: true,
                    [permissionKeys.CAGE_GENERAL_ENDEXPEDITION]: true,
                    [permissionKeys.CAGE_GENERAL_MARKERSETTINGS]: true,
                    [permissionKeys.CAGE_GENERAL_ALARMS]: true,
                    [permissionKeys.CAGE_GENERAL_ENDSETTLEMENT]: true,
                    [permissionKeys.CAGE_GENERAL_NEWINSERTION]: true,
                },
            },
            [permissionKeys.IPSUM]: {
                [permissionKeys.IPSUM_GENERAL]: {
                    [permissionKeys.IPSUM_GENERAL_SETSCHEDULE]: true,
                    [permissionKeys.IPSUM_GENERAL_LOCKFEEDING]: true,
                    [permissionKeys.IPSUM_GENERAL_ALARMS]: true,
                    [permissionKeys.IPSUM_GENERAL_WEIGHTTARING]: true,
                    [permissionKeys.IPSUM_GENERAL_EXTRAFEEDING]: true,
                    [permissionKeys.IPSUM_GENERAL_EMPTYDISPENSER]: true,
                    [permissionKeys.IPSUM_GENERAL_ALARMSETTINGS]: true,
                    [permissionKeys.IPSUM_GENERAL_SETTLEMENTEDIT]: true,
                    [permissionKeys.IPSUM_GENERAL_SETTLEMENTADD]: true,
                    [permissionKeys.IPSUM_GENERAL_CHOOSEFORAGE]: true,
                },
            },
            [permissionKeys.NUTRIPRO]: {
                [permissionKeys.NUTRIPRO_GENERAL]: {
                    [permissionKeys.NUTRIPRO_GENERAL_FEEDINGCURVE]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_SETSCHEDULE]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_LOCKFEEDING]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_ALARMS]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_EXTRAFEEDING]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_EMPTYDISPENER]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_SETTLEMENTEDIT]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_SETTLEMENTADD]: true,
                    [permissionKeys.NUTRIPRO_GENERAL_CHOOSEFORAGE]: true,
                },
            },
            [permissionKeys.SILO]: {
                [permissionKeys.SILO_GENERAL]: {
                    [permissionKeys.SILO_GENERAL_ALARMS]: true,
                    [permissionKeys.SILO_GENERAL_CHOOSEFORAGE]: true,
                    [permissionKeys.SILO_GENERAL_NAME]: true,
                    [permissionKeys.SILO_GENERAL_AUTOTARE]: true,
                },
            },
            [permissionKeys.WATER]: {
                [permissionKeys.WATER_GENERAL]: {
                    [permissionKeys.WATER_GENERAL_ALARMSETTINGS]: true,
                    [permissionKeys.WATER_GENERAL_SETTLEMENTEDIT]: true,
                    [permissionKeys.WATER_GENERAL_SETTLEMENTADD]: true,
                },
            },
            [permissionKeys.ELECTRICITY]: {
                [permissionKeys.ELECTRICITY_GENERAL]: {
                    [permissionKeys.ELECTRICITY_GENERAL_ALERT]: true,
                    [permissionKeys.ELECTRICITY_GENERAL_SETTLEMENTEDIT]: true,
                    [permissionKeys.ELECTRICITY_GENERAL_SETTLEMENTADD]: true,
                    [permissionKeys.ELECTRICITY_GENERAL_SWITCHMETER]: true,
                },
            },
            [permissionKeys.VEHICLEWEIGHT]: {
                [permissionKeys.VEHICLEWEIGHT_GENERAL]: {
                    [permissionKeys.VEHICLEWEIGHT_GENERAL_DOTARE]: true,
                    [permissionKeys.VEHICLEWEIGHT_GENERAL_REPEATWEIGHTING]: true,
                },
            },
            [permissionKeys.CHAINFEEDING]: {
                [permissionKeys.CHAINFEEDING_GENERAL]: {
                    [permissionKeys.CHAINFEEDING_GENERAL_CONFIGURATION]: true,
                    [permissionKeys.CHAINFEEDING_GENERAL_STARTMOTOR]: true,
                    [permissionKeys.CHAINFEEDING_GENERAL_STOPMOTOR]: true,
                    [permissionKeys.CHAINFEEDING_GENERAL_DELETEALARM]: true,
                },
            },
            [permissionKeys.RESULTS]: {
                [permissionKeys.RESULTS_GENERAL]: {
                    [permissionKeys.RESULTS_GENERAL_MANAGECOUNTER]: true,
                    [permissionKeys.RESULTS_GENERAL_EDITGOAL]: true,
                    [permissionKeys.RESULTS_GENERAL_PRINT]: true,
                    [permissionKeys.RESULTS_GENERAL_EXCEL]: true,
                },
                [permissionKeys.RESULTS_CHANGERANGES]: {
                    [permissionKeys.RESULTS_CHANGERANGES_WEEKDAY]: true,
                    [permissionKeys.RESULTS_CHANGERANGES_WEEKS]: true,
                    [permissionKeys.RESULTS_CHANGERANGES_MONTHS]: true,
                    [permissionKeys.RESULTS_CHANGERANGES_YEAR]: true,
                    [permissionKeys.RESULTS_CHANGERANGES_TECHNOLOGYGROUP]: true,
                    [permissionKeys.RESULTS_CHANGERANGES_GROUP]: true,
                },
                [permissionKeys.RESULTS_DATES]: {
                    [permissionKeys.RESULTS_DATES_SOW]: true,
                    [permissionKeys.RESULTS_DATES_WEANER]: true,
                    [permissionKeys.RESULTS_DATES_PORKER]: true,
                    [permissionKeys.RESULTS_DATES_GILT]: true,
                    [permissionKeys.RESULTS_DATES_REPRODUCTION]: true,
                    [permissionKeys.RESULTS_DATES_PARTURITIONS]: true,
                    [permissionKeys.RESULTS_DATES_SEPARATION]: true,
                },
                [permissionKeys.RESULTS_TECHNOLOGYGROUP]: {
                    [permissionKeys.RESULTS_TECHNOLOGYGROUP_REPRODUCTION]: true,
                    [permissionKeys.RESULTS_TECHNOLOGYGROUP_PARTURITIONS]: true,
                    [permissionKeys.RESULTS_TECHNOLOGYGROUP_SEPARATION]: true,
                },
                [permissionKeys.RESULTS_GROUP]: {
                    [permissionKeys.RESULTS_GROUP_GENERAL]: true,
                    [permissionKeys.RESULTS_GROUP_WEANER]: true,
                    [permissionKeys.RESULTS_GROUP_PORKER]: true,
                    [permissionKeys.RESULTS_GROUP_GILT]: true,
                },
            },
            [permissionKeys.REPORTS]: {
                [permissionKeys.REPORTS_VIEW]: {},
                [permissionKeys.REPORTS_GENERATE]: {},
                [permissionKeys.REPORTS_DELETE]: {},
            },
            [permissionKeys.FARM]: {
                [permissionKeys.FARM_SOW]: {},
                [permissionKeys.FARM_WEANER]: {},
                [permissionKeys.FARM_PORKER]: {},
                [permissionKeys.FARM_BOAR]: {},
                [permissionKeys.FARM_GILT]: {},
            },
            [permissionKeys.SETTINGS]: {
                [permissionKeys.SETTINGS_GENERAL]: {
                    [permissionKeys.SETTINGS_GENERAL_GENERAL]: true,
                    [permissionKeys.SETTINGS_GENERAL_BUILDING]: true,
                    [permissionKeys.SETTINGS_GENERAL_DEVICES]: true,
                    [permissionKeys.SETTINGS_GENERAL_CLIMATES]: true,
                    [permissionKeys.SETTINGS_GENERAL_CAGE]: true,
                    [permissionKeys.SETTINGS_GENERAL_FARMWATCH]: true,
                    [permissionKeys.SETTINGS_GENERAL_BREEDING]: true,
                    [permissionKeys.SETTINGS_GENERAL_ECONOMY]: true,
                    [permissionKeys.SETTINGS_GENERAL_FEEDING]: true,
                    [permissionKeys.SETTINGS_GENERAL_SILO]: true,
                    [permissionKeys.SETTINGS_GENERAL_ROUTINES]: true,
                    [permissionKeys.SETTINGS_GENERAL_TASKS]: true,
                    [permissionKeys.SETTINGS_GENERAL_VALIDATIONS]: true,
                    [permissionKeys.SETTINGS_GENERAL_CHARTS]: true,
                    [permissionKeys.SETTINGS_GENERAL_SOWCARDGENERATOR]: true,
                    [permissionKeys.SETTINGS_GENERAL_CLOUDBOX]: true,
                },
            },
            [permissionKeys.PROJECTS]: {
                [permissionKeys.PROJECTS_GENERAL]: {
                    // [permissionKeys.PROJECTS_GENERAL_VIEW]: true,
                    [permissionKeys.PROJECTS_GENERAL_CREATE]: false,
                    [permissionKeys.PROJECTS_GENERAL_DELETE]: false,
                    [permissionKeys.PROJECTS_GENERAL_ASSIGN]: false,
                    [permissionKeys.PROJECTS_GENERAL_COLOR]: false,
                    [permissionKeys.PROJECTS_GENERAL_DASHBOARD]: true,
                    [permissionKeys.PROJECTS_GENERAL_NAME]: false,
                },
            },
            [permissionKeys.TASKS]: {
                [permissionKeys.TASKS_GENERAL]: {
                    [permissionKeys.TASKS_GENERAL_CREATE]: true,
                    [permissionKeys.TASKS_GENERAL_DELETE]: true,
                },
                [permissionKeys.TASKS_EDIT]: {
                    [permissionKeys.TASKS_EDIT_NAME]: true,
                    [permissionKeys.TASKS_EDIT_ASSIGNEDUSER]: true,
                    [permissionKeys.TASKS_EDIT_STARTDATE]: true,
                    [permissionKeys.TASKS_EDIT_ENDDATE]: true,
                    [permissionKeys.TASKS_EDIT_OBSERVERS]: true,
                    [permissionKeys.TASKS_EDIT_LIST]: true,
                    [permissionKeys.TASKS_EDIT_ADDFILE]: true,
                    [permissionKeys.TASKS_EDIT_COMMENT]: true,
                    [permissionKeys.TASKS_EDIT_CHANGESTATUS]: true,
                    [permissionKeys.TASKS_EDIT_CATEGORY]: true,
                    [permissionKeys.TASKS_EDIT_CLOSEASSIGNED]: false,
                    [permissionKeys.TASKS_EDIT_DESCRIPTION]: true,
                },
            },
        },
    };
    //Dodawanie raportów
    const view = tmp.Data[permissionKeys.REPORTS][permissionKeys.REPORTS_VIEW];
    const generate =
        tmp.Data[permissionKeys.REPORTS][permissionKeys.REPORTS_GENERATE];
    const deleteReports =
        tmp.Data[permissionKeys.REPORTS][permissionKeys.REPORTS_DELETE];
    const skipKeys = ["Q101", "Q102", "Q103", "Q104", "Q105", "Q106"];
    for (const key in reportType) {
        if (!skipKeys.includes(key)) {
            const viewKey = `PV_RE_REPORT-VIEW-${reportType[key]}`;
            const generatekey = `PV_RE_REPORT-GENERATE-${reportType[key]}`;
            const deleteKey = `PV_RE_REPORT-DELETE-${reportType[key]}`;

            if (!deleteReports.hasOwnProperty(deleteKey)) {
                deleteReports[deleteKey] = true;
            }
            if (!generate.hasOwnProperty(generatekey)) {
                generate[generatekey] = true;
            }
            if (!view.hasOwnProperty(viewKey)) {
                view[viewKey] = true;
            }
        }
    }

    //TWOZRENIE HODOWLI
    const eventList = getEventsList((name) => name, null, "ALL");
    const animals = {
        SOW: [],
        WEANER: [],
        PORKER: [],
        BOAR: [],
        GILT: [],
    };

    for (let event of eventList) {
        for (let animal of event.eligibleAnimal) {
            event.value = getValueOfEventPicker(event.value);
            const animalKey = getAnimalKeyByAnimalType(animal);
            animals[animalKey].push(event);
        }
    }
    const farm = tmp.Data[permissionKeys.FARM];
    Object.keys(animals).map((item) => {
        for (let obj of animals[item]) {
            const animalObj = permissionKeys[`FARM_${item}`];
            if (farm[animalObj])
                if (
                    !farm[animalObj].hasOwnProperty(`${animalObj}_${obj.value}`)
                ) {
                    farm[animalObj][`${animalObj}_${obj.value}`] = true;
                }
        }
    });
    return tmp;
};

export function canUserChangeStatus(task, localUserID) {
    if (!task || !localUserID) return false;
    return task.AssignTo === localUserID || task.AuthorID === localUserID;
}
